import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import CommonHeaderStore from '@src/business-components/common-header/store';
import Link from '@src/components/link';
import cx from 'classnames';
const styles = require('./index.less');

const MAIN_ROUTE_URL = `${window.location.origin}${window.location.pathname}#/`;

const CommonHeader = ({ store }) => {
  // store.use();
  return (
    <div className={styles.noSignBox}>
      <div className="fixed-nav">
        <div className="index-naviBarBox-32Xmp">
          <div className="index-root-1oCwC index-rootAct-1PGOT aos-init aos-animate" data-aos="fade-in" data-aos-once="true">
            <div
              className={cx('index-expandNaviBar-144m5', store.isMax && 'index-height458-2kGP9', store.show && 'index-expandNav-3o139')}
              onMouseLeave={() => {
                store.showMenu(false);
              }}
            >
              <div className={cx('index-whiteNaviBarContainer-2khMZ', store.isMax && 'index-maxWidth-243XT')}>
                <div className="index-whiteNaviBarTop-2ndrd">
                  <Link href="https://www.seasungames.cn/#/" target="_blank" className="index-link-1lu9o index-blackLogo-2HnX_" />
                </div>
                <div className="index-whiteNaviBarBottom-gX8wH">
                  <div className="index-whiteNaviBarBottomLeft-21hdy">
                    <div className="index-boutiqueGamesList-36JEy">
                      <div className="index-expandNavBarTitle-jUxVn">精品游戏</div>
                      <div className="index-expandRecommendGameList-HNG0o">
                        <Link className="index-link-1lu9o index-recommendGameItem-1Z9k2" href="https://jx3.seasungames.cn?utm_source=ssg" target="_blank">
                          <div
                            className="index-recommendGameIcon-2Royv"
                            style={{ backgroundImage: 'url("https://www.xishanju.com/uploadfile/2024/0627/20240627103945676.jpg")' }}
                          />
                          <div className="index-recommendGameName-3KPLG">剑网3/剑网3无界</div>
                        </Link>
                        <Link
                          className="index-link-1lu9o index-recommendGameItem-1Z9k2"
                          href="https://mechabreak.seasungames.cn?utm_source=ssg"
                          target="_blank"
                        >
                          <div
                            className="index-recommendGameIcon-2Royv"
                            style={{ backgroundImage: 'url("https://www.xishanju.com/uploadfile/2024/0627/20240627103955735.jpg")' }}
                          />
                          <div className="index-recommendGameName-3KPLG">解限机</div>
                        </Link>
                        <Link className="index-link-1lu9o index-recommendGameItem-1Z9k2" href="https://www.cbjq.com/" target="_blank">
                          <div
                            className="index-recommendGameIcon-2Royv"
                            style={{ backgroundImage: 'url("https://www.xishanju.com/uploadfile/2024/0627/20240627104012367.jpg")' }}
                          />
                          <div className="index-recommendGameName-3KPLG">尘白禁区</div>
                        </Link>
                      </div>
                      <div className="index-expandRecommendGameMoreBtn-2oXp2">
                        <Link
                          className="index-link-1lu9o index-expandRecommendGameMoreBtnContent-y4QxQ"
                          target="_blank"
                          href="https://www.seasungames.cn/#/games"
                        >
                          更多游戏
                        </Link>
                        <div className={cx('index-arrowIcon_dark-3t2G9', styles.arrowIcon_dark)} />
                      </div>
                    </div>
                    <div className="index-dividerLine-BZWV4" />
                    <div className="index-linkContainer-1w7YN">
                      <div className="index-linkCol-1xGQ_">
                        <div className="index-expandNavBarTitle-jUxVn">官方工具</div>
                        <div className="index-linkList-1M1WA">
                          <div className="index-linkItem-3J8n7">
                            <Link className="index-link-1lu9o index-linkItemContent-iaigv" href="https://g.xoyo.com/#/" target="_blank">
                              启动器
                            </Link>
                          </div>
                          <div className="index-linkItem-3J8n7">
                            <Link className="index-link-1lu9o index-linkItemContent-iaigv" href="https://www.seasunwbl.com/" target="_blank">
                              万宝楼
                            </Link>
                          </div>
                          <div className="index-linkItem-3J8n7">
                            <Link className="index-link-1lu9o index-linkItemContent-iaigv" href="https://www.xoyo.com/apps" target="_blank">
                              游戏管家
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="index-linkCol-1xGQ_">
                        <div className="index-expandNavBarTitle-jUxVn">用户服务</div>
                        <div className="index-linkList-1M1WA">
                          <div className="index-linkItem-3J8n7">
                            <Link
                              className="index-link-1lu9o index-linkItemContent-iaigv"
                              href="https://passport.xoyo.com/signin?redirect=https%3A%2F%2Fcharge.xoyo.com%2Fcharge-items"
                              target="_blank"
                            >
                              充值中心
                            </Link>
                          </div>
                          <div className="index-linkItem-3J8n7">
                            <Link
                              className="index-link-1lu9o index-linkItemContent-iaigv"
                              href="https://passport.xoyo.com/signin?redirect=https%3A%2F%2Fi.xoyo.com%2F"
                              target="_blank"
                            >
                              个人中心
                            </Link>
                          </div>
                          <div className="index-linkItem-3J8n7">
                            <Link className="index-link-1lu9o index-linkItemContent-iaigv" href="https://support.seasungames.cn/" target="_blank">
                              客服中心
                            </Link>
                          </div>
                          <div className="index-linkItem-3J8n7">
                            <Link className="index-link-1lu9o index-linkItemContent-iaigv" href="https://help.xoyo.com/help?category=4115" target="_blank">
                              帮助中心
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="index-linkCol-1xGQ_">
                        <div className="index-expandNavBarTitle-jUxVn">了解我们</div>
                        <div className="index-linkList-1M1WA">
                          <div className="index-linkItem-3J8n7">
                            <Link className="index-link-1lu9o index-linkItemContent-iaigv" href="https://www.xoyo.com/news-list" target="_blank">
                              新闻资讯
                            </Link>
                          </div>
                          <div className="index-linkItem-3J8n7">
                            <Link className="index-link-1lu9o index-linkItemContent-iaigv" href="https://about.seasungames.cn/" target="_blank">
                              企业文化
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="index-linkCol-1xGQ_">
                        <div className="index-expandNavBarTitle-jUxVn">加入我们</div>
                        <div className="index-linkList-1M1WA">
                          <div className="index-linkItem-3J8n7">
                            <Link className="index-link-1lu9o index-linkItemContent-iaigv" href="https://job.seasungames.cn/" target="_blank">
                              社会招聘
                            </Link>
                          </div>
                          <div className="index-linkItem-3J8n7">
                            <Link className="index-link-1lu9o index-linkItemContent-iaigv" href="https://job.seasungames.cn/campus" target="_blank">
                              校园招聘
                            </Link>
                          </div>
                          <div className="index-linkItem-3J8n7">
                            <Link className="index-link-1lu9o index-linkItemContent-iaigv" href="https://sc.xishanju.com/#/" target="_blank">
                              训练营
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="index-whiteNaviBarBottomRight-3S52U">
                    <div className="index-root-18qoj">
                      <div className="index-swiperBox-H9Vr4">
                        <div className="swiper-container swiper-container-initialized swiper-container-horizontal">
                          <div className="swiper-wrapper" style={{ transform: 'translate3d(0px, 0px, 0px)' }}>
                            <div className="swiper-slide index-listItem-27cDU swiper-no-swiping swiper-slide-active">
                              <img src="https://www.xishanju.com/uploadfile/2024/0628/20240628071910365.png" alt="" />
                            </div>
                          </div>
                          <span className="swiper-notification" aria-live="assertive" aria-atomic="true" />
                        </div>
                      </div>
                      <div className="index-content-3RRyG">西山居以创造快乐、传递快乐、分享快乐为使命，致力于成为游 戏玩家的圣地。</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={cx('index-expandNavCover-2dZNV', store.show && 'index-showNavCover-3GYYP')} />
            <div className={cx('index-mainNaviBar-3R8bI', store.isMax && 'index-maxWidth-243XT')}>
              <div className="index-mainNavBarContainer-iO1nM">
                <div className="index-leftBox-13pCe">
                  <div
                    className="index-logoMenu-2o3dc"
                    onMouseEnter={() => {
                      store.showMenu(true);
                    }}
                  >
                    <div className="index-logoIcon-3ujWd" />
                    <div className="index-arrowIcon-2oTzj" />
                  </div>
                  <Link
                    className="index-jx_logo-2B2HW"
                    href={MAIN_ROUTE_URL}
                    aria-label="剑侠世界4：无限官网首页"
                    onClick={event => {
                      event.preventDefault();
                      store.goToMain();
                    }}
                  />
                  <div className="tab-wrap">
                    {store.navList.map((item, index) => {
                      return (
                        <Link
                          className={cx('tab-item', { cur: store.current === index })}
                          href={item.id === 0 ? MAIN_ROUTE_URL : undefined}
                          key={index}
                          onClick={event => {
                            if (item.id === 0) {
                              event.preventDefault();
                            }
                            store.setCurrent(item.id, 'click');
                          }}
                        >
                          <div className="tab">{item.title}</div>
                        </Link>
                      );
                    })}
                  </div>
                </div>
                <div className="index-nav_btn_right-2-iAS">
                  <img src={require('./images/logo2.png')} alt="" />
                </div>
              </div>
              <div className="index-bg-3qped" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default wrapStore(CommonHeader, CommonHeaderStore);
